import { useMemo } from 'react'
import { EColorScheme } from '../theme'

interface UseQueryParamsResult {
  colorScheme: EColorScheme
  cname: string
}

/**
 * Hook to parse query string parameters for theme and API configuration
 *
 * Supported params:
 * - theme=light|dark (default: light)
 * - cname=<name> (default: api) - Maps to https://{cname}.allotrac.io
 */
export const useQueryParams = (): UseQueryParamsResult => {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return {
        colorScheme: EColorScheme.LIGHT,
        cname: 'api',
      }
    }

    const params = new URLSearchParams(window.location.search)

    // Theme parameter
    const themeParam = params.get('theme')
    const colorScheme = themeParam === 'dark' ? EColorScheme.DARK : EColorScheme.LIGHT

    // CNAME parameter
    const cname = params.get('cname') || 'api'

    return {
      colorScheme,
      cname,
    }
  }, [])
}
